module.exports = __webpack_public_path__ + "static/media/235.40c9b2ae.webp";